
const HilightCard = ({children}) => {
    return <div className="infocard rounded p-4 mt-3">{children}</div>
}

export default HilightCard;
